// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportUI_wrapper__dL2Jd {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.ReportUI_header__AUHNF {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ReportUI_back__neoRv {
  display: flex;
  align-items: center;
  color: var(--orange);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 26px;
}

.ReportUI_loader__dAnci {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.ReportUI_back__neoRv:hover {
  color: var(--orange);
}

.ReportUI_backButton__TQTWM {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--orange);
  color: white;
  margin-right: 15px;
}

.ReportUI_orders__v01On {
  margin-top: 30px;
}

.ReportUI_search__4l1Of {
  width: 200px;
  margin-right: 15px;
}

.ReportUI_input__tf4yq button {
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
  border-color: #c9c9c9;
}

.ReportUI_input__tf4yq input {
  color: #7e7e7e !important;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
  border-color: #c9c9c9;
}

.ReportUI_picker__859NM {
  border-color: #c9c9c9;
  border-radius: 5px !important;
  margin-right: 15px;
}

.ReportUI_preparationIcon__9XHxI {
  width: 20px;
  height: 20px;
}

.ReportUI_eye__aXvmP {
  background-color: transparent;
  color: var(--orange);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  cursor: pointer;
}

.ReportUI_eye__aXvmP svg {
  width: 22px;
  height: 22px;
}
  `, "",{"version":3,"sources":["webpack://./src/pages/reports/styles/ReportUI.module.css"],"names":[],"mappings":"AAAA;EACI,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".wrapper {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  \n  .back {\n    display: flex;\n    align-items: center;\n    color: var(--orange);\n    font-family: BebasNeue;\n    font-weight: 700;\n    font-size: 26px;\n  }\n  \n  .loader {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 1;\n  }\n  \n  .back:hover {\n    color: var(--orange);\n  }\n  \n  .backButton {\n    width: 30px;\n    height: 30px;\n    border-radius: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--orange);\n    color: white;\n    margin-right: 15px;\n  }\n  \n  .orders {\n    margin-top: 30px;\n  }\n  \n  .search {\n    width: 200px;\n    margin-right: 15px;\n  }\n  \n  .input button {\n    border-top-right-radius: 5px !important;\n    border-bottom-right-radius: 5px !important;\n    border-color: #c9c9c9;\n  }\n  \n  .input input {\n    color: #7e7e7e !important;\n    border-top-left-radius: 5px !important;\n    border-bottom-left-radius: 5px !important;\n    border-color: #c9c9c9;\n  }\n  \n  .picker {\n    border-color: #c9c9c9;\n    border-radius: 5px !important;\n    margin-right: 15px;\n  }\n  \n  .preparationIcon {\n    width: 20px;\n    height: 20px;\n  }\n  \n  .eye {\n    background-color: transparent;\n    color: var(--orange);\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n    cursor: pointer;\n  }\n  \n  .eye svg {\n    width: 22px;\n    height: 22px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ReportUI_wrapper__dL2Jd`,
	"header": `ReportUI_header__AUHNF`,
	"back": `ReportUI_back__neoRv`,
	"loader": `ReportUI_loader__dAnci`,
	"backButton": `ReportUI_backButton__TQTWM`,
	"orders": `ReportUI_orders__v01On`,
	"search": `ReportUI_search__4l1Of`,
	"input": `ReportUI_input__tf4yq`,
	"picker": `ReportUI_picker__859NM`,
	"preparationIcon": `ReportUI_preparationIcon__9XHxI`,
	"eye": `ReportUI_eye__aXvmP`
};
export default ___CSS_LOADER_EXPORT___;
